@for (counter of visibleCounters; track trackByCounters($index, counter)) {
  @switch (counter.type) {
    @case (CounterTypes.CounterWithLabel) {
      <div class="counter">
        <rt-heading variant="heading large-x">
          {{ counter.value }}
        </rt-heading>

        <span>
          {{ counter.label }}
        </span>
      </div>
    }

    @case (CounterTypes.CounterWithBudget) {
      <div class="counter new">
        <rt-badge color="primary" text="{{ counter.value }} {{ counter.label }}"></rt-badge>
      </div>
    }

    @case (CounterTypes.CounterWithIcon) {
      <div
        class="counter disqualified-count"
        margin-left-small-xx
        [rtTooltip]="counter.label"
        [rtTooltipPosition]="'below'"
      >
        <rt-icon [name]="counter.options!.iconName!" margin-right-small-xx></rt-icon>
        <span>{{ counter.value }}</span>
      </div>
    }
  }
}
